export default function errorDialog(mainIssue: string, moreInfo: string) {
    alert(`An error has occured. Please report this. \n \n Main issue: ${mainIssue} \n More info: ${moreInfo}`);
    throw new Error(`${mainIssue  } ${  moreInfo}`);
}